import '../../../ui/view/modules/SaveLoad.js';
import Modal from '../../../ui/view/comps/Modal.js';
import Snackbar from '../../../ui/view/comps/Snackbar.js';

import {
    addEvents,
    createImgThumbnail,
    localStorageAvailable
} from '../../../helpers/utils.js';
import { getScaleByDimesions } from '../../../fabricjs/utils.js';

export default class SaveLoadModule extends EventTarget {

    constructor(fpdInstance, wrapper) {

        super();

        this.fpdInstance = fpdInstance;

        this.container = document.createElement("fpd-module-save-load");
        this.wrapper = wrapper
        this.wrapper.append(this.container);

        this.inputElem = this.container.querySelector('input');
        this.gridElem = this.container.querySelector('.fpd-grid');

        this.storageId = "fpd-saved-designs"

        addEvents(
            this.container.querySelector('.fpd-btn'),
            'click',
            (evt) => {

                const scale = getScaleByDimesions(
                    this.fpdInstance.currentViewInstance.options.stageWidth,
                    this.fpdInstance.currentViewInstance.options.stageHeight,
                    300,
                    300,
                    'cover'
                );

                fpdInstance.viewInstances[0].toDataURL((thumbnail) => {

                    const product = this.fpdInstance.getProduct(this.fpdInstance.mainOptions.saveOnlyEditableElements);
                    const title = this.inputElem.value || '';
                    const savedProduct = {
                        thumbnail: thumbnail,
                        product: product,
                        title: title,
                        url: window.location.href
                    };

					if(product && this.fpdInstance.mainOptions.saveActionBrowserStorage) {

						//check if there is an existing products array
						let savedProducts = this.#getSavedProducts();
						if(!savedProducts) {
							savedProducts = [];
						}

                        this.addSavedProduct(savedProduct);

						savedProducts.push(savedProduct);
						window.localStorage.setItem(
                            this.fpdInstance.container.id,
                            JSON.stringify(savedProducts)
                        );

						Snackbar(this.fpdInstance.translator.getTranslation('misc', 'product_saved'));

					}

                    if(product) {

                        this.fpdInstance.dispatchEvent(
                            new CustomEvent('actionSave', {detail: savedProduct})
                        );

                        this.fpdInstance.doUnsavedAlert = false;

                    }


				}, {multiplier: scale, format: 'png', backgroundColor:'transparent'});

            }
        )

        if(this.fpdInstance.mainOptions.saveActionBrowserStorage) {

            let savedProducts = this.#getSavedProducts();
            if(savedProducts && savedProducts.length > 0) {

                savedProducts.forEach((savedProduct) => {
                    this.addSavedProduct(savedProduct);
                })

            }

        }

    }

    //returns an object with the saved products for the current showing product
	#getSavedProducts() {
		return localStorageAvailable() ? JSON.parse(window.localStorage.getItem(this.fpdInstance.container.id)) : false;
	}

    //add a saved product to the load dialog
    addSavedProduct({thumbnail, product, title='', url}) {

        const thumbnailElem = createImgThumbnail({
            url: thumbnail,
            title: title,
            removable: true,
            disablePrice: true,
            disableDraggable: true
        });

        this.fpdInstance.lazyBackgroundObserver.observe(thumbnailElem.querySelector('picture'));

        thumbnailElem.product = product;
        thumbnailElem.originalUrl = url

        this.gridElem.append(thumbnailElem);

        addEvents(
            thumbnailElem,
            'click',
            (evt) => {
                if(this.fpdInstance.mainOptions.saveOnlyEditableElements) {
                    let mergedProduct = this.fpdInstance.getProduct()
                    mergedProduct = mergedProduct.map((view, index) => {
                        if(thumbnailElem.product[index]?.elements.length > 0) {
                            view.elements.push(... thumbnailElem.product[index]?.elements);
                        }
                        return view;
                    })
                    this.fpdInstance.loadProduct(mergedProduct);
                } else {
                    if(thumbnailElem.originalUrl != window.location.href) {
                        this.#switchProduct(thumbnailElem.originalUrl)
                    } else {
                        this.fpdInstance.loadProduct(thumbnailElem.product);
                    }
                }
		        this.fpdInstance.currentProductIndex = -1;

            }
        );

        addEvents(
            thumbnailElem.querySelector('.fpd-delete'),
            'click',
            (evt) => {

                evt.stopPropagation();

                const itemElem = evt.currentTarget.parentNode;
                const index = Array.from(this.gridElem.querySelectorAll('.fpd-item')).indexOf(itemElem);

                if(this.fpdInstance.mainOptions.saveActionBrowserStorage) {

                    let savedProducts = this.#getSavedProducts();
                        savedProducts.splice(index, 1);

                    window.localStorage.setItem(
                        this.fpdInstance.container.id,
                        JSON.stringify(savedProducts)
                    );

                }

                this.fpdInstance.dispatchEvent(
                    new CustomEvent('actionLoad:Remove', {detail: {
                        index: index,
                        item: itemElem,
                    }})
                );

                itemElem.remove();

            }
        );

        return thumbnailElem;

	}

    #switchProduct(url) {
        document.querySelector(".fpd-draggable-dialog .fpd-icon-close")?.click()

        var confirmModal = Modal(
            this.fpdInstance.translator.getTranslation(
			    'modules',
				'save_load_switch_page'
			),
            false,
            'confirm',
            this.fpdInstance.container
        );

        const confirmBtn = confirmModal.querySelector('.fpd-confirm');
        confirmBtn.innerText = this.fpdInstance.translator.getTranslation(
            'modules',
            'save_load_confirm'
        )

        addEvents(
            confirmBtn,
            ['click'],
            () => {

                window.location.href = url
                confirmModal.remove();

            }
        )
    }

}

window.FPDSaveLoadModule = SaveLoadModule;